var $ = require('jQuery');
var _ = require('underscore');
var Regions = require('../../lib/regions.js');

module.exports = function() {

  new Regions($('.countries'), function(regions) {
    // Region field replaces state field
    $('input[name="state"]').val('');

    // Insert regions directly after city
    regions.insertAfter($('.form-group-city'));
  });

  // Show discount code input
  $('.apply-discount-code').on('click', function(e) {
  	e.preventDefault();
    $('.discount-code-form').toggleClass('hidden');
  });

  // @TODO: Remove when we drop IE8/9 support
  var isIE9OrBelow = function()
  {
    return /MSIE\s/.test(navigator.userAgent) && parseFloat(navigator.appVersion.split("MSIE")[1]) < 10;
  }

  var updateCart = function() {
	var data = $('#cart-form').serialize();

    // @TODO: Remove when we drop IE8/9 support
    var url = isIE9OrBelow() ? "/cart/update" : "/cart";

    $.pjax({ url: url, data: data, container: '#pjaxContainer', method: 'POST', preserveScrollPosition: true });
  };

  $("input[name=paymentMethod]:radio, input[name=currency]:radio, input[name=entryFee]:radio, input[name=entrantFee]:radio").on("change", function() {
    updateCart();
  });

  $("#country, .select-region").on("change", _.debounce( function() {
    updateCart();
  }, 800 ));

  $('input[name^="entry-fee-member-number"], input[name^="entrant-fee-member-number"]').on('change', function() {
    $('input[name="memberNumber"]').val($(this).val());
  });

  $('#setDiscountCode').click(function(e) {
      e.preventDefault();
      updateCart();
  });

  // Update cart if the value of the VAT number input changes
  var vatNumber = '';

  $('#vat-number').on('focus', function () {
    vatNumber = $(this).val();
  });

  $('#vat-number').on('blur', function () {
    if ($(this).val() != vatNumber) {
      updateCart();
    }
  });

  $('#process-payment').on('click', function(e) {
    e.disabled = true;
    $('#cart-form').submit();
    return true;
  });
};
